import { render, staticRenderFns } from "./commonTags.vue?vue&type=template&id=bd3a6c9e&scoped=true&"
import script from "./commonTags.vue?vue&type=script&lang=js&"
export * from "./commonTags.vue?vue&type=script&lang=js&"
import style0 from "./commonTags.vue?vue&type=style&index=0&id=bd3a6c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3a6c9e",
  null
  
)

export default component.exports